import styled from 'styled-components/macro'
import breakpoints from 'assets/stylesheet'

const FilterSection = styled.div`
  position: relative;
  ${props =>
    props.isDocumentSection &&
    `
  margin-top: 5px;
  `}
  @media (max-width: ${breakpoints.bpPhonePx}) {
    ${props =>
      props.isDocumentSection &&
      `
  `}
  }
`

export default FilterSection
